import type { ReactNode } from "react";
import { FeedbackState, type FeedbackKind } from "./PortalPrimitives";

// SPEC-201 §4.4 preserves its three consumer-facing cases through the
// canonical feedback primitive; backend error details never reach the UI.
export type EmptyStateKind = "no-data" | "no-results" | "error";

const feedbackByEmptyState: Record<EmptyStateKind, FeedbackKind> = {
  "no-data": "empty",
  "no-results": "filtered-empty",
  error: "error",
};

export function EmptyState({
  kind,
  action,
}: {
  kind: EmptyStateKind;
  action?: ReactNode;
}) {
  return <FeedbackState kind={feedbackByEmptyState[kind]} action={action} />;
}
